import { render } from "./PersonalitiesMainPublications.vue?vue&type=template&id=83a26ae8"
import script from "./PersonalitiesMainPublications.vue?vue&type=script&lang=js"
export * from "./PersonalitiesMainPublications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__